import React from 'react'
import { Section } from '@shared/components/section'

import { RiskPoints } from '../riskPoints'

import styles from './style.module.scss'

interface Props {
	title?: string
}

export const View = ({ title }: Props) => {
	return (
		<Section className={styles.wrapper} fullWidth>
			{title && <h2 className={styles.sectionTitle}>{title}</h2>}
			<RiskPoints />
		</Section>
	)
}
